<!-- Page Header -->
<app-title-bar
  title="Campaigns"
  description="Track and manage campaigns by company"
  [showButton]="false"
>
</app-title-bar>

<!-- Search and Filter Section -->
<div class="search-filter-section">
  <app-searchbar
    placeholder="Search for campaigns."
    [(searchTerm)]="searchTerm"
    (searchChange)="onSearchChange($event)"
    iconSize="small"
  >
  </app-searchbar>

  <div class="filter-container">
    <!-- Company Dropdown -->
    <app-simple-dropdown
      [options]="companyOptions"
      [selectedValue]="selectedCompanyId"
      [title]="'Select Company'"
      [isOpen]="isCompanyDropdownOpen"
      (selectionChange)="selectCompany($event)"
      (toggle)="toggleCompanyDropdown()"
      (close)="closeCompanyDropdown()"
    >
    </app-simple-dropdown>

    <app-action-button
      buttonText="Filter"
      iconSrc="assets/images/package/adjustments.svg"
      [showCount]="hasActiveFilters"
      [count]="getActiveFilterCount()"
      (buttonClick)="onFilter()"
    >
    </app-action-button>
  </div>
</div>

<!-- Campaigns Table (Only show when there are campaigns to display) -->
<div *ngIf="!loading && campaigns.length > 0" class="table-container">
  <div class="table-scroll-wrapper" #tableScrollWrapper>
    <table class="orders-table">
      <thead>
        <tr>
          <th (click)="sortByName()" style="cursor: pointer">
            Campaign Name
            <img [src]="getSortIcon('name')" alt="Sort" class="sort-icon" />
          </th>
          <th>Status</th>
          <th>Promo Code</th>

          <th>Start Date</th>
          <th>End Date</th>
          <th>Platforms</th>
          <th>Locations</th>
          <th>Performance</th>
          <th>Goals</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let campaign of campaigns; trackBy: trackById" class="order-row">
          <td class="order-id" [title]="campaign.name">{{ campaign.name || '-' }}</td>
          <td>
            <span
              [ngClass]="{
                'status-active': campaign.status?.toLowerCase() === 'active',
                'status-scheduled': campaign.status?.toLowerCase() === 'scheduled',
                'status-completed': campaign.status?.toLowerCase() === 'completed',
                'status-draft': campaign.status?.toLowerCase() === 'draft',
              }"
            >
              {{ getStatusLabel(campaign.status) || '-' }}
            </span>
          </td>
          <td class="voucher-code">{{ campaign.promoCode || '-' }}</td>

          <td class="date-time">{{ campaign.startDate || '-' }}</td>
          <td class="date-time">{{ campaign.endDate || '-' }}</td>
          <td>{{ formatPlatforms(campaign.platforms) || '-' }}</td>
          <td>{{ formatLocations(campaign.locations) || '-' }}</td>
          <td>
            <app-campaign-performance-cell [campaign]="campaign" />
          </td>
          <td>
            <div class="goals-cell">
              <div class="goal-item" *ngFor="let goal of campaign.goals; trackBy: trackByIndex">
                <span class="p5"
                  >{{ goal.goal_name }}: {{ goal.achieved || 0 }} / ({{ goal.target_value }})</span
                >
              </div>
              <div class="goal-item" *ngIf="!campaign.goals || campaign.goals.length === 0">
                <span class="p5">No goals set</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Loading State - Shimmer Effect -->
<div *ngIf="loading" class="loading-container">
  <app-loading-table-shimmer
    [columns]="shimmerColumns"
    [rows]="10"
    [showHeader]="false"
    className="scrollable"
  >
  </app-loading-table-shimmer>
</div>

<!-- Empty State - No Campaigns (when there are truly no campaigns) -->
<div
  *ngIf="!loading && campaigns.length === 0 && !hasSearchOrFilters && selectedCompanyId"
  class="empty-state-container"
>
  <app-empty-result
    image="/assets/images/empty_screen.png"
    title="No campaigns to show"
    description="No campaigns found for the selected company."
    [actionText]="''"
    [showAction]="false"
  >
  </app-empty-result>
</div>

<!-- Empty State - No Company Selected -->
<div *ngIf="!loading && !selectedCompanyId" class="empty-state-container">
  <app-empty-result
    image="/assets/images/empty_screen.png"
    title="Select a company"
    description="Please select a company to view campaigns."
    [actionText]="''"
    [showAction]="false"
  >
  </app-empty-result>
</div>

<!-- Empty State - No Search Results (when search/filters are active but no results) -->
<div
  *ngIf="!loading && campaigns.length === 0 && hasSearchOrFilters && selectedCompanyId"
  class="empty-state-container"
>
  <app-empty-result
    image="/assets/images/empty_screen.png"
    title="No results found!"
    description="Please try again or modify your search or filters."
    [actionText]="''"
    [showAction]="false"
  >
  </app-empty-result>
</div>

<!-- Pagination -->
<app-pagination-bar
  *ngIf="!loading && campaigns.length > 0"
  [paginationData]="paginationData"
  [itemsPerPageOptions]="[10, 25, 50]"
  (pageChange)="onPageChange($event)"
  (itemsPerPageChange)="onItemsPerPageChange($event)"
>
</app-pagination-bar>

<!-- Filter Modal -->
<app-filter-modal
  [isVisible]="showFilterModal"
  header="Filters"
  primaryButtonText="Apply Filters"
  secondaryButtonText="Clear Filters"
  [categories]="filterCategories"
  (close)="onCloseFilterModal()"
  (apply)="onFilterModalApply($event)"
>
</app-filter-modal>
